export enum PageContentStatus {
    Loading,
    StandardError,
    SupplyError,
    Success,
}
